import {I18n} from 'aws-amplify/utils';
import {Box} from '@mantine/core';
import {
    ReloadButton,
    SimplePageHeader,
} from '@flexinet/ui-components';

import {useZones} from '../hooks/useZones';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton';
import config from '../config';

const ZonesReloadButton = () => {
    const {reload} = useZones();
    return (
        <Box mx={'s'}>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};

const useTools = () => {
    // READ HALF (FNP-1191): Filter and Reload only.
    //
    // ─── RESERVED FOR THE CRUD FOLLOW-UP ───
    // An Add Zone button belongs here, rendered only when
    // useZoneWriteCapabilities(...).canCreateZones is true. The hiding decision
    // is already built and tested — see hooks/useZoneWriteCapabilities — so the
    // follow-up adds the button and its drawer, not the plumbing.
    //
    // Nothing is stubbed in the meantime: a disabled Add button would promise a
    // capability the schema cannot serve today.
    return [
        <FilterRecordsButton key={'filter'}/>,
        <ZonesReloadButton key={'reload'}/>,
    ];
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
